// AdblockDetectOverlay.tsx
'use client';
import { useEffect, useState } from 'react';

export default function AdblockDetectOverlay() {
  const [adblock, setAdblock] = useState(false);

  useEffect(() => {
    // Try to load a real Monetag ad script and check if it loads
    let scriptLoaded = false;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://nap5k.com/tag.min.js'; // Monetag in-page ad script
    script.onload = () => { scriptLoaded = true; setAdblock(false); };
    script.onerror = () => { setAdblock(true); };
    document.body.appendChild(script);

    // Fallback: if script neither loads nor errors in 1s, assume not blocked
    const timeout = setTimeout(() => {
      if (!scriptLoaded) setAdblock(false);
      if (script.parentNode) script.parentNode.removeChild(script);
    }, 1000);

    return () => {
      clearTimeout(timeout);
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);

  if (!adblock) return null;

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(20,20,20,0.97)',
      color: '#fff',
      zIndex: 99999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.3rem',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <h2 style={{ fontSize: '2rem', marginBottom: '1.5rem' }}>🚫 We noticed you’re using an ad blocker</h2>
      <p style={{ maxWidth: 500, marginBottom: '2rem' }}>
        Our content is free thanks to ads. Please consider whitelisting our site or disabling your ad blocker so you can enjoy the full experience.
      </p>
      <button
        onClick={handleReload}
        style={{
          background: '#22c55e',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          padding: '0.8rem 2rem',
          fontSize: '1.1rem',
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
        }}
      >
        ✅ I’ve disabled my ad blocker
      </button>
    </div>
  );
}
